<script>
export default {
  data() {
    return {
      code: this.$route.params?.productCode
    };
  }
};
</script>
<template>
  <div>
    <BaseProductModal :code="code" :value="true"> </BaseProductModal>
  </div>
</template>
